module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-10 col-sm-offset-1"
  }, [_c('radar-chart', {
    attrs: {
      "chartData": {
        labels: _vm.seznamPodskupin.map(function (el) { return _vm.$options.filters.stripHtml(_vm.$options.filters.pickTranslation(el.name)); }),
        datasets: [{
          label: _vm.$t('pages.subgroups.coverage'),
          backgroundColor: 'rgba(0, 166, 90, 0.4)',
          borderColor: 'rgba(0, 166, 90)',
          pointBorderColor: 'rgba(0, 166, 90)',
          data: _vm.points
        }]
      },
      "options": {
        scale: {
          ticks: {
            min: -0.1,
            max: _vm.adminView ? Math.max.apply(Math, _vm.points) : 1
          },
          pointLabels: {
            fontSize: 13
          }
        }
      }
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-34661116", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34661116"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/groups/SpiderChart.vue
// module id = 1428
// module chunks = 1